import { configureStore } from '@reduxjs/toolkit';

import * as reducers from 'src/app/v1/state/modules';

export const configureRenderStore = () =>
  configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  });
